import { render, staticRenderFns } from "./SGShardedClusterMonitoring.vue?vue&type=template&id=74b3d311&scoped=true"
import script from "./SGShardedClusterMonitoring.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterMonitoring.vue?vue&type=script&lang=js"
import style0 from "./SGShardedClusterMonitoring.vue?vue&type=style&index=0&id=74b3d311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b3d311",
  null
  
)

export default component.exports